module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_40.a8d00a12.png";